export default "__VITE_ASSET__WBqapZ7d__"